import { WarningOutlined } from "@ant-design/icons";

const SupportInterventionStats = ({ stats, loading }) => {
  const scheduled = stats?.scheduled?.length || 0;
  const notPicked = stats?.notPicked?.length || 0;
  const notDelivered = stats?.notDelivered?.length || 0;

  const statItems = [
    {
      title: "Scheduled (Next day/Retail/Wholesale)",
      value: scheduled,
      icon: <WarningOutlined className="text-blue-600" size={24} />,
      color: "bg-blue-50",
    },
    {
      title: "Not Picked (45m)",
      value: notPicked,
      icon: <WarningOutlined className="text-yellow-600" size={24} />,
      color: "bg-yellow-50",
    },
    {
      title: "Not Delivered (45m)",
      value: notDelivered,
      icon: <WarningOutlined className="text-red-600" size={24} />,
      color: "bg-red-50",
    },
  ];

  if (loading) {
    return (
      <div className="flex gap-4 overflow-x-auto pb-4 snap-x snap-mandatory scrollbar-hide">
        {[...Array(8)].map((_, index) => (
          <div
            key={index}
            className="bg-white rounded-lg p-5 shadow-sm min-w-[280px] sm:min-w-[320px] snap-start flex-shrink-0 animate-pulse"
          >
            <div className="flex items-start justify-between mb-3">
              <div className="bg-gray-200 p-2 rounded-lg w-12 h-12"></div>
            </div>
            <div className="text-gray-600  mb-1 h-4 bg-gray-200 rounded w-20"></div>
            <div className="text-3xl font-bold text-gray-900 mb-3 h-8 bg-gray-200 rounded w-16"></div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="flex gap-4 overflow-x-auto pb-4 snap-x snap-mandatory scrollbar-hide">
      {statItems.map((stat, index) => (
        <div
          key={index}
          className="bg-white rounded-lg p-5 shadow-sm min-w-[280px] sm:min-w-[320px] snap-start flex-shrink-0"
        >
          <div className="flex items-start justify-between mb-3">
            <div className={`${stat.color} p-2 rounded-lg`}>{stat.icon}</div>
          </div>
          <div className="text-gray-600  mb-1">{stat.title}</div>
          <div className="text-3xl font-bold text-gray-900 mb-3">
            {stat.isFormatted ? stat.value : stat.value.toLocaleString()}
          </div>
        </div>
      ))}
    </div>
  );
};

export default SupportInterventionStats;
